import styled from '@emotion/styled';

import { getColor } from '../UICommon';
import { TabletWidth } from '../../../global.style';

export const PaymentSummaryWrapper = styled.div`
  background-color: ${getColor('LIGHT_CREAM')};
  max-width: 400px;
  padding-block: 56px;

  @media (max-width: ${TabletWidth}px) {
    max-width: 100%;
    margin-bottom: 0px;
    padding: 32px 24px 24px;
  }
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${getColor('GRAY_80')};
`;

export const PlanNameRow = styled(SummaryRow)`
  margin-bottom: 24px;
`;

export const CouponRow = styled(SummaryRow)`
  margin-bottom: 8px;
`;

export const SubtotalRow = styled(SummaryRow)`
  margin-bottom: 8px;
`;

export const TotalSumRow = styled(SummaryRow)`
  margin-top: 20px;
  font-size: 18px;
`;

export const SummaryRowItem = styled.span``;

export const SummaryDivider = styled.div`
  height: 1px;
  background-color: ${getColor('GRAY_40')};
`;

export const GreenText = styled.span`
  color: ${getColor('SYSTEM_GREEN')};
`;

export const KlarnaSubtitle = styled(SummaryRow)`
  margin-top: 4px;
`;
